'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Dropdown = require('../Dropdown-59ebfb4f.js');
var FloatingLabelInput_TextInput_index = require('./TextInput/index.js');
require('../tslib.es6-130a177d.js');
require('react');
require('styled-components');
require('../viewport.utils-aaaff74b.js');
require('../Icons/ArrowIcon/index.js');
require('../FloatingLabel.styles-249af1a1.js');
require('../browser.utils-bfcc05c6.js');
require('../typography/index.js');
require('react-dom');
require('../useOutsideClick-531afbb5.js');
require('../useForceUpdateRef-6d1ca28f.js');
require('../scroll-10f2cb64.js');
require('../Icons/ShowIcon/index.js');
require('../Icons/HideIcon/index.js');
require('../Icons/ValidIcon/index.js');
require('../Icons/CrossIcon/index.js');



exports.FloatingLabelDropdown = Dropdown.FloatingLabelDropdown;
exports.Hint = FloatingLabelInput_TextInput_index.Hint;
exports.default = FloatingLabelInput_TextInput_index['default'];
//# sourceMappingURL=index.js.map
